import { render, staticRenderFns } from "./PsdEdit.vue?vue&type=template&id=ab931a9a&scoped=true&"
import script from "./PsdEdit.vue?vue&type=script&lang=js&"
export * from "./PsdEdit.vue?vue&type=script&lang=js&"
import style0 from "./PsdEdit.vue?vue&type=style&index=0&id=ab931a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab931a9a",
  null
  
)

export default component.exports